document.addEventListener('DOMContentLoaded', function () {
    var popupOverlay = document.querySelector('.popup-custom-image-overlay');
    if (!popupOverlay) return;

    var closeButton = document.querySelector('.popup-custom-close');
    var form = document.querySelector('.popup-custom-form-container form');
    var successMessage = document.querySelector('.popup-message-success');
    var container = document.querySelector('.popup-custom-image-container');
    var copyButtons = document.querySelectorAll('.popup-copy-coupon');

    var delay = parseInt(popupOverlay.dataset.delay, 10);
    if (Number.isNaN(delay)) delay = 5000;

    var daysToHide = parseInt(popupOverlay.dataset.expiry, 10);
    if (Number.isNaN(daysToHide)) daysToHide = 30;
    // A chave inclui a campanha (Personalizador): trocar a campanha reexibe o popup para todos.
    var popupId = 'popup_custom_' + (popupOverlay.dataset.campaign || popupOverlay.id || 'default');

    function hydratePopupBackground() {
        if (!container || container.dataset.bgHydrated === '1') return;
        var desktopBg = container.getAttribute('data-bg-desktop');
        var mobileBg = container.getAttribute('data-bg-mobile');
        if (desktopBg) container.style.setProperty('--popup-bg', "url('" + desktopBg + "')");
        if (mobileBg) container.style.setProperty('--popup-bg-mobile', "url('" + mobileBg + "')");
        container.dataset.bgHydrated = '1';
    }

    function showPopup() {
        hydratePopupBackground();
        popupOverlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
    }

    function markSeen() {
        if (daysToHide > 0) localStorage.setItem(popupId, new Date().getTime().toString());
    }

    function hidePopup() {
        popupOverlay.classList.remove('is-visible');
        document.body.style.overflow = '';
        markSeen();
    }

    // Telefone: o formulário de newsletter do Shopify não grava telefone, então o número
    // (DDD + 8 ou 9 dígitos) vai como tag do cliente no formato tel:+55DDNNNNNNNNN.
    var phoneInput = document.getElementById('PopupFormPhone');
    var tagsInput = document.getElementById('PopupFormTags');
    function syncPhoneTag() {
        if (!phoneInput || !tagsInput) return;
        var digits = phoneInput.value.replace(/\D/g, '');
        if (digits.indexOf('55') === 0 && digits.length >= 12) digits = digits.slice(2);
        var valido = digits.length === 10 || digits.length === 11;
        phoneInput.setCustomValidity(valido ? '' : 'Informe o telefone com DDD, ex.: 44 99999-9999');
        var base = tagsInput.getAttribute('data-base') || 'newsletter, popup';
        tagsInput.value = valido ? base + ', tel:+55' + digits : base;
    }
    if (phoneInput) {
        phoneInput.addEventListener('input', syncPhoneTag);
        phoneInput.addEventListener('blur', syncPhoneTag);
        syncPhoneTag();
    }
    if (form) form.addEventListener('submit', syncPhoneTag, true);

    // Fechar
    if (closeButton) closeButton.addEventListener('click', hidePopup);
    popupOverlay.addEventListener('click', function (e) {
        if (e.target === popupOverlay) hidePopup();
    });

    // Copiar cupom
    function handleCopyClick(button) {
        var coupon = button.getAttribute('data-coupon') || '';
        if (!coupon) return;
        var originalText = button.textContent;
        function setCopiedText() {
            button.textContent = 'Copiado!';
            setTimeout(function () { button.textContent = originalText; }, 1500);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(coupon).then(setCopiedText).catch(setCopiedText);
        } else {
            var tempInput = document.createElement('input');
            tempInput.value = coupon;
            document.body.appendChild(tempInput);
            tempInput.select();
            try { document.execCommand('copy'); } catch (e) { /* ignore */ }
            document.body.removeChild(tempInput);
            setCopiedText();
        }
    }
    if (copyButtons.length) {
        copyButtons.forEach(function (button) {
            button.addEventListener('click', function () { handleCopyClick(button); });
        });
    }

    // === Cadastro concluído ===
    // O formulário envia de forma NATIVA (necessário p/ o reCAPTCHA do Shopify gerar o token
    // e o cliente ser criado de fato). No sucesso o Shopify volta pra cá com ?popup_ok=1.
    var params = new URLSearchParams(window.location.search);
    if (params.get('popup_ok') === '1') {
        if (form) form.style.display = 'none';
        if (successMessage) successMessage.style.display = 'block';
        showPopup();
        markSeen(); // já cadastrou: não mostrar de novo
        params.delete('popup_ok');
        var qs = params.toString();
        var cleanUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
        window.history.replaceState({}, document.title, cleanUrl);
        return;
    }

    // === Popup normal (formulário) — respeita o "não mostrar por X dias" ===
    var lastClosed = localStorage.getItem(popupId);
    if (lastClosed && daysToHide > 0) {
        if (new Date().getTime() - parseInt(lastClosed, 10) < daysToHide * 24 * 60 * 60 * 1000) {
            return; // ainda dentro do período oculto
        }
    }

    // Dispara após a primeira interação (não rouba o LCP); fallback por tempo.
    var popupScheduled = false;
    function schedulePopup() {
        if (popupScheduled) return;
        popupScheduled = true;
        setTimeout(showPopup, delay);
    }
    ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (eventName) {
        window.addEventListener(eventName, schedulePopup, { passive: true, once: true });
    });
    setTimeout(schedulePopup, 15000);

    // Obs.: NÃO interceptamos o submit. O clique no botão envia o form nativamente,
    // o reCAPTCHA invisível do Shopify entra, o cliente é gravado e volta com ?popup_ok=1.
});
